var RaqTool = (function () {


  Utility.log('RaqTool loaded');

  var disclaimerTimeout = null;

  var initDealerInfo = function () {
    var $prefDlrInput = $('input#isPreferredInput');

    var handlePrefDlrStatus = function ($input) {
      var $prefDlrLabel = $input.closest('label[for=isPreferredInput]');
      if ($input.prop('checked')) {
        $prefDlrLabel.addClass('is-preferred');
        $input.addClass('is-preferred');
      } else {
        $prefDlrLabel.removeClass('is-preferred');
        $input.removeClass('is-preferred');
      }
    };

    var wrapPhoneNbr = function () {
      // wraps phone number in <span> tag to support brand-styling
      var $phoneLink = $('.raq-dealer-info .raq-dealer-info-detail.phone > a');

      if ($phoneLink.length > 0) {
        var $icon = $phoneLink.find('i').clone();
        var phoneStr = $phoneLink.text().trim();
        var $phoneSpan;

        if (phoneStr) {
          $phoneSpan = $('<span>' + phoneStr + '</span>');
          $phoneLink.empty('').append($icon);
          $phoneLink.append($phoneSpan);
        }
      }
    };

    // Call function on initial page-load.
    handlePrefDlrStatus($prefDlrInput);

    // Listen to ALL preferred-dealer checkbox clicks.
    // Some pages will have this checkbox not only on the page, but
    // also in RAQ modal (opened via on-page CTAs).
    $(document.body).on('change', 'input#isPreferredInput', function (e) {
      // console.log('Preferred-Dealer input changed!  event object:...');
      // console.log(e);

      handlePrefDlrStatus($(e.originalEvent.target));
    });

    setTimeout(function () {
      wrapPhoneNbr();
    }, 1500);
  };

  // Convert RAQ disclaimers to ACR ready (For standalone version)
  var buildDisclaimers = function () {
    var disclaimers = document.querySelectorAll('raq-wrapper sup.disclaimer');
    var currDisclaimer;
    for (var i = 0; i < disclaimers.length; i++) {
      currDisclaimer = disclaimers[i];
      var copy = currDisclaimer.getAttribute('description');
      var title = currDisclaimer.getAttribute('title');
      currDisclaimer.setAttribute('data-copy', copy);
      currDisclaimer.setAttribute('data-title', title);
      currDisclaimer.setAttribute('data-number', currDisclaimer.innerText);
      currDisclaimer.setAttribute('data-target', '#acura-disclaimer');
      currDisclaimer.classList.add('acr-sup');
    }
  };

  var initDisclaimers = function () {
    clearTimeout(disclaimerTimeout);
    disclaimerTimeout = setTimeout(buildDisclaimers, 1000);
  };

  // BEGIN initForms functions
  var initForms = function (scope) {
    var queryScope = scope && typeof scope === 'string' ? scope + ' ' : '';

    var raqForm = $(queryScope + '.raq-form');

    customizeSelects(raqForm);

    attachFormListeners(raqForm);

    if ($('html').hasClass('ie11')) {
      // IE11 doesn't support pseudo-element with svg background-image.
      // Need add a label after checkboxes to support custom-styling.
      insertLabel(raqForm.find('input[type="checkbox"][name="terms"]'));
    }
  };

  var handleCustomDropdownPrompt = function ($nativeSelect) {
    // console.log('[RaqTool.js] handleCustomDropdownPrompt() called!');
    // handle any required custom-dropdown's .select-box-prompt (add/remove red asterisk)
    var regexKey = $nativeSelect.data('regexkey');

    if (regexKey) {
      if (regexKey === 'simplyRequired') {
        var $parent = $nativeSelect.parent();
        var $clone = $nativeSelect.next('.acr-select-box-cloned');
        var $clonePrompt = $clone.find('.select-box-prompt');

        $clonePrompt.addClass('required');
        $clonePrompt.addClass('acr-paragraph-8');

        $parent.on('selectBoxOptionHidden', function () {
          // console.log('[RaqTool.js] handleCustomDropdownPrompt(): selectBoxOptionHidden evt fired!');
          if ($nativeSelect.val() !== '') {
            $clonePrompt.removeClass('required');
          } else {
            $clonePrompt.addClass('required');
          }
        });
      }
    }
  };

  var customizeSelects = function ($form) {
    $form.find('select').each(function () {
      var $currSelect = $(this);
      var currSelectId = $currSelect.attr('id');
      var currSelector = '#' + $form.attr('id') + ' #' + currSelectId;

      if (currSelectId !== 'state') {
        SelectBox.createSelect(currSelector, undefined, 'raq-form-class');
      } else {
        SelectBox.createSelect(currSelector, function () {
          // console.log('[RaqTool.js] customizeSelects(): selectBox callback called!');
          setTimeout(function () {
            handleCustomDropdownPrompt($currSelect);
          }, 500);
        }, 'raq-form-class');
      }
    });
  };

  var insertLabel = function ($field, labelText) {
    // inserts label after field element passed in.
    // get/set field ID
    var fieldId = $field.attr('id');
    var $label;
    if (!fieldId) {
      $field.attr('id', $field.attr('name'));
      fieldId = $field.attr('id');
    }

    // insert <label> if none exists before/after $field.
    if (
      $field.prev('label').length === 0
      && $field.next('label').length === 0
    ) {
      $label = $('<label for="' + fieldId + '"></label>');
      if (labelText) {
        $label.text(labelText);
      } else {
        // without label-text, add classhook to enable css vertical-alignment.
        $label.addClass('no-text');
      }
      $field.after($label);
    }
  };

  var stateCheckInterval = null;
  var statePrevValue = '';
  var checkStateChange = function ($stateSelect) {
    // Runs on setInterval (stateCheckInterval above).
    // If State gets changed, change custom-dropdown selection.
    // Clear/reset interval when User makes selection -- this method should only update
    // custom-dropdown for dynamic selection by Gray-tool code.
    var stateCurrValue = $stateSelect.val();

    if (stateCurrValue !== statePrevValue) {
      // console.log('[RaqTool.js] checkStateChange(): State value changed to ' + stateCurrValue);
      var $clone = $stateSelect.next('.acr-select-box-cloned');
      var $cloneOptions = $clone.find('.acr-select-box-options');
      var $cloneOptionSpan = $cloneOptions.find('ul li span[data-value="' + stateCurrValue + '"]');
      var $clonePrompt = $clone.find('.acr-select-box-top-wrapper .select-box-prompt');

      SelectBox.selectOption(
        $clone,
        $cloneOptions,
        $cloneOptionSpan,
        false,
      );

      statePrevValue = stateCurrValue;

      // handle $clonePrompt required classhook (red asterisk)
      if (stateCurrValue === '') {
        $clonePrompt.addClass('required');
      } else {
        $clonePrompt.removeClass('required');
      }

      // console.log('[RaqTool.js] checkStateChange(): State custom-dropdown selection updated to ' +
      //   stateCurrValue);
    }
  };

  var handleUserStateSelection = function ($nativeSelectParent) {
    // Clears/resets stateCheckInterval above when User (not Gray-tool code) makes State selection.
    var $stateSelect = $nativeSelectParent.find('select#state');

    $nativeSelectParent.on('selectBoxOptionShown', function (e) {
      // console.log('[RaqTool.js] handleUserStateSelection(): selectBoxOptionShown event fired!');
      if (stateCheckInterval !== null) {
        clearInterval(stateCheckInterval);
        stateCheckInterval = null;
      }
    });

    $nativeSelectParent.on('selectBoxOptionHidden', function () {
      // console.log('[RaqTool.js] handleUserStateSelection(): selectBoxOptionHidden event fired!');
      setTimeout(function () {
        if (stateCheckInterval === null) {
          statePrevValue = $stateSelect.val();
          stateCheckInterval = setInterval(function () {
            checkStateChange($stateSelect);
          }, 250);
        }
      }, 500);
    });
  };

  var attachFormListeners = function ($form) {
    $('input', '.raq-form').on('focus', onFocus);
    $('input', '.raq-form').on('blur', onBlur);

    // Listen indirectly for dynamic State selection by gray-tool script.
    stateCheckInterval = setInterval(function () {
      checkStateChange($('select#state', $form));
    }, 250);
    // Handle stateCheckInterval clear/reset when User makes State selection.
    handleUserStateSelection($('.raq-form-box.state', $form));
  };

  var onFocus = function (e) {
    $(this).addClass('acr-not-empty');
  };

  var showHidePlaceholder = function ($input) {
    if ($input.val()) {
      $input.addClass('acr-not-empty');
    } else {
      $input.removeClass('acr-not-empty');
    }
  };

  var onBlur = function (e) {
    showHidePlaceholder($(e.target));
  };
  // END initForms functions

  // BEGIN initRaq functions
  var stubScriptsFound = false;
  var stubScriptsRAQFound = false;

  var initRaq = function (modalSelector) {
    stubScriptsFound = false;
    stubScriptsRAQFound = false;

    var stubScripts = ' stubScriptsSection ';
    var stubScriptsRAQ = ' stubScriptsSectionRAQ ';

    var contents = document.querySelector(modalSelector);
    var nodes = contents.childNodes;

    // console.log('contents: ', contents);
    // console.log('nodes: ', nodes);

    for (var i = 0; i <= nodes.length; ++i) {
      if (nodes[i] && nodes[i].nodeType === 8
          && nodes[i].nodeValue.toString() === stubScripts && !stubScriptsFound) {
        stubScriptsFound = true;
        getScript(nodes[i].nextSibling, i, nodes);
      } else if (nodes[i] && nodes[i].nodeType === 8
                && nodes[i].nodeValue.toString() === stubScriptsRAQ && !stubScriptsRAQFound) {
        stubScriptsRAQFound = true;
        getScript(nodes[i].nextSibling, i, nodes);
      }
    }
  };

  var getScript = function (node, position, nodes) {
    var i = 0;

    if (node.attributes && node.attributes[0] && node.attributes[0].nodeValue === 'text/javascript') {
      appendScript(node);
    } else {
      for (i = position; i <= nodes.length; ++i) {
        if (nodes[i].attributes && nodes[i].attributes[0] && nodes[i].attributes[0].nodeValue === 'text/javascript') {
          appendScript(nodes[i]);
          break;
        }
      }
    }
  };

  var appendScript = function (script) {
    var domBody = null;
    var domScript = null;

    domBody = document.querySelector('body');
    domScript = document.createElement('script');
    domScript.setAttribute('type', 'text/javascript');
    domScript.innerHTML = script.innerHTML;
    domBody.appendChild(domScript);
    domBody.removeChild(domScript);

    // console.log('domScript.innerHTML: ', domScript);

    if (stubScriptsFound && stubScriptsRAQFound) {
      // Init RAQ-UI app after scripts were injected on host page
      startRaq();
    }
  };

  function addresCompleted() {
    showHidePlaceholder($('.raq-form input[name=city]'));
  }

  var startRaq = function () {
    var sitecoreExpEditor = !!(window.Sitecore
                    && window.Sitecore.WebEditSettings
                    && window.Sitecore.WebEditSettings.editing);

    if (!window.BaP) {
      sessionStorage.removeItem('bapAccessories');
    }
    if (window['raq-ui'] && window['raq-ui'].init && !sitecoreExpEditor) {
      var raqUI = window['raq-ui'].init();

      hideUntilFetched();
      initForms();
      initDisclaimers();

      raqUI.bus.on(raqUI.bus.EVENTS.FORM.ADDRESS_AUTOCOMPLETED, addresCompleted);
    }
  };

  var hideUntilFetched = function () {
    $('body').addClass('is-loading');

    // we have no event to know when RAQ is loaded so using a timeout to prevent
    //  the flashing issue on load
    setTimeout(function () {
      $('.modal-raq .modal-content, offers-modal-wrapper.modal-raq .ui-modal-container ')
        .css('display', 'block');
      $('body').removeClass('is-loading');
      $('body').addClass('modal-open');
    }, 500);
  };
  // END initRaq functions

  $(window).on('ar.closemodal', function () {
    $('.modal-raq .modal-content').removeAttr('style');
  });

  return {
    initDealerInfo: initDealerInfo,
    initForms: initForms,
    initRaq: initRaq,
    initDisclaimers: initDisclaimers,
  };
}());
